import React, { useState } from "react";
import { db, auth } from "../../firebase";
import { collection, query, where, getDocs, updateDoc, doc, arrayUnion } from "firebase/firestore";
import { useTheme } from "../../context/ThemeContext";

export default function JoinSquad({ onClose, initialInviteCode = "" }) {
    const [inviteCode, setInviteCode] = useState(initialInviteCode);
    const [loading, setLoading] = useState(false);
    const { isDarkMode } = useTheme();

    const handleJoin = async (e) => {
        e.preventDefault();
        if (!inviteCode.trim()) return;

        setLoading(true);
        try {
            const q = query(collection(db, "squads"), where("inviteCode", "==", inviteCode.trim().toUpperCase()));
            const querySnapshot = await getDocs(q);

            if (querySnapshot.empty) {
                alert("Invalid invite code.");
                setLoading(false);
                return;
            }

            const squadDoc = querySnapshot.docs[0];
            const squadData = squadDoc.data();
            const currentUid = auth.currentUser.uid;

            if (squadData.members.includes(currentUid)) {
                alert("You are already a member of this Squad.");
                onClose();
                return;
            }

            if (squadData.members.length >= 300) {
                alert("This Squad is full (Max 300 members).");
                setLoading(false);
                return;
            }

            await updateDoc(doc(db, "squads", squadDoc.id), {
                members: arrayUnion(currentUid)
            });

            alert(`Joined ${squadData.name}!`);
            onClose();
        } catch (error) {
            console.error("Error joining squad:", error);
            alert("Failed to join squad.");
        } finally {
            setLoading(false);
        }
    };

    const bgClass = isDarkMode ? "bg-slate-800 text-white" : "bg-white text-gray-800";
    const inputClass = isDarkMode
        ? "bg-slate-700 border-slate-600 text-white placeholder-gray-400"
        : "bg-gray-50 border-gray-300 text-gray-900";

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
            <div className={`w-full max-w-sm rounded-2xl shadow-2xl p-6 ${bgClass} animate-fade-in-up`}>
                <div className="flex justify-between items-center mb-6">
                    <h2 className="text-xl font-bold bg-gradient-to-r from-green-400 to-blue-500 bg-clip-text text-transparent">
                        Join a Squad
                    </h2>
                    <button onClick={onClose} className="p-2 hover:bg-white/10 rounded-full transition-colors">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                    </button>
                </div>

                <form onSubmit={handleJoin} className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium mb-1 opacity-80">Invite Code</label>
                        <div className="relative">
                            <input
                                type="text"
                                value={inviteCode}
                                onChange={(e) => setInviteCode(e.target.value.toUpperCase())}
                                className={`w-full rounded-lg pl-10 pr-4 py-3 border focus:ring-2 focus:ring-green-500 outline-none transition-all tracking-widest font-mono uppercase text-center ${inputClass}`}
                                placeholder="ABC123"
                                maxLength={6}
                                required
                            />
                            <div className="absolute left-3 top-3.5 opacity-50">#</div>
                        </div>
                    </div>

                    <div className="pt-2">
                        <button
                            type="submit"
                            disabled={loading}
                            className="w-full py-3 rounded-xl bg-gradient-to-r from-green-500 to-blue-600 text-white font-bold shadow-lg hover:shadow-green-500/30 transition-all transform active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            {loading ? "Joining..." : "Join Squad"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
